import axios from "./api";
class Authentification {
  register(data) {
    return axios.post("/auth/register", data);
  }

  confirmEmail() {
    return axios.post("/auth/confirm_email");
  }

  refreshLink(data) {
    return axios.post("/auth/refreshLink", data);
  }

  /* {
    'grant_type' => 'password',
    'client_id' => 'client-id',
    'client_secret' => 'client-secret',
    'username' => 'taylor@laravel.com',
    'password' => 'my-password',
    'scope' => '',
  } */
  /**{
      'grant_type' => 'refresh_token',
      'refresh_token' => 'the-refresh-token',
      'client_id' => 'client-id',
      'client_secret' => 'client-secret',
      'scope' => '',
    } ); */

  refreshToken() {
    return axios.post("/oauth/tokens");
  }

  getCurrentUser() {
    return axios.get("/auth/user");
  }

  login(data) {
    return axios.post("/auth/login", data);
  }

  resetPassword(data) {
    return axios.post(`auth/reset/password`, data);
  }

  updatePassword(data) {
    return axios.post(`/auth/updatePassword`, data);
  }

  changePassword(data) {
    return axios.post(`/auth/changePassword`, data);
  }

  logout() {
    const clearAndReload = (data) => {
      localStorage.clear();
      window.location.reload();
    };
    axios
      .post(`/auth/logout`)
      .then((res) => {
        clearAndReload();
      })
      .catch((err) => clearAndReload());
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Authentification();
